import * as moment from 'moment';

import styles from './Document.module.css';

import React, { Component } from 'react';

import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';

import addIcon from './../icons/ic_add_circle.svg';
import downloadIcon from './../icons/ic_download.svg';
import uploadIcon from './../icons/ic_upload.svg';
import deleteIcon from './../icons/ic_delete.svg';

import headerImage from './../images/modules/document.jpg';
import { CPLBanner } from '../../../components/Banner';

import { ReactSVG } from 'react-svg';

import { LanguageContext } from '../../../i18n/LanguageContext';

import { DocumentService } from '../../../services/ApiService';

import { sprintf } from 'sprintf-js';

export default class DocumentModule extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            mode: 'create',
            documents: [],
            search: '',
            showEditor: false,
            document: null,
            title: '',
            DocumentID: null,
            showConfirmDeleteModal: false,
            successModalShow: false
        }

        this.onSearch = this.onSearch.bind(this);
        this.onDocumentClicked = this.onDocumentClicked.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCreate = this.onCreate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onDownload = this.onDownload.bind(this);
        this.onConfirmDelete = this.onConfirmDelete.bind(this);
        this.onCancelConfirmDelete = this.onCancelConfirmDelete.bind(this);
        this.hideSuccessModal = this.hideSuccessModal.bind(this);
    }

    onSearch(search) {
        this.setState({ search: search });
    }

    onCancel() {
        this.setState({ showEditor: false });
    }

    onDelete(id) {
        let title = '';
        for(let document of this.state.documents) {
            if(document.id === id) {
                title = document.title[this.context['LANG']];
                break;
            }
        }
        this.setState({ 
            DocumentID: id,
            showConfirmDeleteModal: true,
            title: title
        });
    }

    onConfirmDelete(id) {
        DocumentService.deleteDocument(id)
            .then(async () => {
                this.setState({ 
                    showEditor: false,
                    showConfirmDeleteModal: false
                });
                await this.getDocuments();
            })
            .catch(e => console.error(e))
    }

    onCancelConfirmDelete() {
        this.setState({ showConfirmDeleteModal: false});
    }

    onDownload(id, fileName) {
        DocumentService.downloadDocument(id)
            .then(async (data) => {
                this.fileDownload(data, fileName);
            })
            .catch(e => console.error(e))
    }

    fileDownload(data, filename) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    }

    onDocumentClicked(document) {
        this.setState({
            mode: 'update',
            showEditor: true,
            document: document
        });
    }

    onCreate() {
        this.setState({ mode: 'create', showEditor: true, document: null });
    }

    async componentDidMount() {
        await this.getDocuments();
    }

    onSave(data, mode) {
        if (mode === 'create') {
            DocumentService.createDocument(data)
                .then(async () => {
                    this.setState({ showEditor: false, successModalShow: true });
                    await this.getDocuments();
                })
                .catch(e => console.error(e))
        } else {
            DocumentService.updateDocument(data)
                .then(async () => {
                    await this.getDocuments();
                    this.setState({ showEditor: false, successModalShow: true });
                })
                .catch(e => console.error(e))
        }

    }

    async getDocuments() {
        let documents = await DocumentService.getAllDocuments();
        documents = documents.map(document => {
            document.titleValue = document.title[this.context['LANG']];
            document.startDate = moment(document.startDate).format('YYYY-MM-DD');
            document.expirationDate = moment(document.expirationDate).format('YYYY-MM-DD');
            return document;
        });
        this.setState({ documents: documents });
    }

    filterDocuments(search, document, properties) {
        for (let prop of properties) {
            if (RegExp(`(.)*${search}(.)*`, 'i').test(document[prop])) {
                return true;
            }
        }
        return false;
    }

    hideSuccessModal() {
        this.setState({successModalShow: false})
    }

    render() {
        let documents = this.state.documents.map(document => {
            document.titleValue = document.title[this.context['LANG']];
            return document;
        });

        if (!!this.state.search) {
            documents = documents
                .filter(document => this.filterDocuments(this.state.search, document, [
                    'titleValue',
                    'expirationDate'
                ]));
        }

        let editor = null;
        if (!!this.state.showEditor) {
            editor = <Editor
                document={this.state.document}
                mode={this.state.mode}
                onSave={this.onSave}
                onDownload={this.onDownload}
                onDelete={this.onDelete}
                onCancel={this.onCancel} />
        }

        return <div className="col-md-12">
            <div className="row banner-wrapper">
                <div className="col-md-12">
                    <CPLBanner
                        img={headerImage}
                        content={this.context['DOCUMENTS']} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-7 col-md-7">
                    <DocumentAdmin
                        documents={documents}
                        onCreate={this.onCreate}
                        onDocumentClicked={this.onDocumentClicked}
                        onSearch={this.onSearch} />
                </div>
                <div className="col-lg-5 col-md-5">
                    {editor}
                </div>
            </div>
            <ConfirmDeleteModal 
                id={this.state.DocumentID}
                title={this.state.title}
                onClose={this.onCancelConfirmDelete}
                context={this.context}
                onDelete={this.onConfirmDelete}
                show={this.state.showConfirmDeleteModal}/>
            <SuccessSaveModal 
                show={this.state.successModalShow}
                onHide={this.hideSuccessModal}/>
        </div>
    }
}

class DocumentAdmin extends Component {
    static contextType = LanguageContext

    constructor(props, context) {
        super(props, context);
        this.state = {
            search: ''
        };

        this.onSearchListener = this.onSearchListener.bind(this);
    }

    onSearchListener(event) {
        this.props.onSearch(event.target.value);
        this.setState({ search: event.target.value });
    }

    render() {
        return <div>
            <div className="card">
                <div className="card-header">
                    {this.context['DOCUMENTS']}
                    <span className="float-right">
                        <OverlayTrigger
                            key="top"
                            placement="top"
                            overlay={<Tooltip>{this.context['ADD']}</Tooltip>}>
                                <div className={styles['panel-button']} onClick={this.props.onCreate}>
                                    <ReactSVG
                                        src={addIcon}
                                        className={styles['add-button']} />
                                </div>
                        </OverlayTrigger>
                    </span>
                    <span className="float-right">
                        <div className={styles['search-form']}>
                            <input type="text" value={this.state.search} onChange={this.onSearchListener} placeholder={`${this.context['SEARCH']}...`} />
                        </div>
                    </span>
                </div>
                <div className="card-body">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th>{this.context['TITLE']}</th>
                                <th>{this.context['EXPIRATION_DATE']}</th>
                            </tr>
                        </thead>
                        <DocumentList
                            lang={this.context}
                            onDocumentClicked={this.props.onDocumentClicked}
                            documents={this.props.documents} />
                    </table>
                </div>
            </div>
        </div>
    }
}

const DocumentList = function (props) {
    return <tbody>
        {props.documents.map((document, index) => {
            document.index = index;

            return <DocumentListItem
                key={index}
                index={index}
                document={document}
                lang={props.lang}
                onDocumentClicked={props.onDocumentClicked}
            />
        })}
    </tbody>
}

const DocumentListItem = function (props) {
    const document = props.document;

    return <tr className={styles['editor-row-clickable']} onClick={() => props.onDocumentClicked(document)}>
        <td>{document.titleValue}</td>
        <td>{document.expirationDate}</td>
    </tr>
}

class Editor extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);

        const document = this.props.document;

        this.state = {
            file: null,
            id: !!document ? document.id : 0,
            titleSpanish: !!document ? document.title.es : '',
            titleEnglish: !!document ? document.title.en : '',
            descriptionSpanish: !!document ? document.description.es : '',
            descriptionEnglish: !!document ? document.description.en : '',
            startDate: !!document ? document.startDate : moment().format('YYYY-MM-DD'),
            expirationDate: !!document ? document.expirationDate : moment().add(1, 'months').format('YYYY-MM-DD'),
            uploadedFileName: null,
            missingArgumentsClass: {
                titleSpanish: styles['editor-form-control'],
                titleEnglish: styles['editor-form-control'],
                descriptionSpanish: styles['editor-form-control'],
                descriptionEnglish: styles['editor-form-control'],
                startDate: styles['editor-form-control'],
                expirationDate: styles['editor-form-control'],
                file: styles['document-file']
            }
        };

        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onExpirationDateChange = this.onExpirationDateChange.bind(this);
        this.onUploadFile = this.onUploadFile.bind(this);
        this.save = this.save.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onDownload = this.onDownload.bind(this);
    }

    onExpirationDateChange(e) {
        this.setState({ expirationDate: e.target.value });
    }

    onStartDateChange(e) {
        this.setState({ startDate: e.target.value });
    }

    onUploadFile(e) {
        const file = e.target.files[0];
        if (!!file) {
            this.setState({ file: file,  uploadedFileName: file['name']});
        }
    }

    getMissingArgumentMap(missingArguments) {
        let missingArgumentsMap = {}
        for (let argument of missingArguments) {
            if(argument === 'file') {
                missingArgumentsMap[argument] = styles['document-file-error'];
            } else {
                missingArgumentsMap[argument] = styles['editor-form-control-error'];
            }
        }

        return {
            ...{
                titleSpanish: styles['editor-form-control'],
                titleEnglish: styles['editor-form-control'],
                descriptionSpanish: styles['editor-form-control'],
                descriptionEnglish: styles['editor-form-control'],
                startDate: styles['editor-form-control'],
                expirationDate: styles['editor-form-control'],
                file: styles['document-file']
            },
            ...missingArgumentsMap
        }
    }

    save() {
        const missingArguments = [];

        if (!this.state.titleSpanish) {
            missingArguments.push('titleSpanish');
        }
        if (!this.state.titleEnglish) {
            missingArguments.push('titleEnglish');
        }
        if (!this.state.descriptionSpanish) {
            missingArguments.push('descriptionSpanish');
        }
        if (!this.state.descriptionEnglish) {
            missingArguments.push('descriptionEnglish');
        }
        if (!this.state.startDate) {
            missingArguments.push('startDate');
        }
        if (!this.state.expirationDate) {
            missingArguments.push('expirationDate');
        }

        if (this.props.mode === 'create') {
            if (!this.state.file) {
                missingArguments.push('file');
            }
        }
        
        if (!!missingArguments.length) {
            this.setState({
                missingArgumentsClass: this.getMissingArgumentMap(missingArguments)
            });
            return;
        }

        if(!moment(this.state.expirationDate).isAfter(this.state.startDate)) {
            return;
        }

        const expirationDate = moment(this.state.expirationDate).utc().toISOString();
        const startDate = moment(this.state.startDate).utc().toISOString();

        const data = {
            title: {
                es: this.state.titleSpanish,
                en: this.state.titleEnglish
            },
            description: {
                es: this.state.descriptionSpanish,
                en: this.state.descriptionEnglish
            },
            expirationDate: expirationDate,
            startDate: startDate,
            file: this.state.file
        };

        if (this.props.mode === 'update') {
            data.id = this.props.document.id;
        }

        this.props.onSave(data, this.props.mode);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.mode === 'update' && this.props.mode === 'create') {
            this.setState({
                id: null,
                file: null,
                titleSpanish: '',
                titleEnglish: '',
                descriptionSpanish: '',
                descriptionEnglish: '',
                startDate: moment().format('YYYY-MM-DD'),
                expirationDate: moment().add(1, 'months').format('YYYY-MM-DD'),
                uploadedFileName: null,
                missingArgumentsClass: {
                    titleSpanish: styles['editor-form-control'],
                    titleEnglish: styles['editor-form-control'],
                    descriptionSpanish: styles['editor-form-control'],
                    descriptionEnglish: styles['editor-form-control'],
                    startDate: styles['editor-form-control'],
                    expirationDate: styles['editor-form-control'],
                    file: styles['document-file']
                }
            });
            return;
        }

        let document;
        if (prevProps.mode === 'create' && this.props.mode === 'update') { 
            document = this.props.document;
            this.setState({
                id: document.id,
                file: null,
                titleSpanish: !!document ? document.title.es : '',
                titleEnglish: !!document ? document.title.en : '',
                descriptionSpanish: !!document ? document.description.es : '',
                descriptionEnglish: !!document ? document.description.en : '',
                startDate: !!document ? document.startDate : moment().format('YYYY-MM-DD'),
                expirationDate: !!document ? document.expirationDate : moment().add(1, 'months').format('YYYY-MM-DD'),
                uploadedFileName: null,
                missingArgumentsClass: {
                    titleSpanish: styles['editor-form-control'],
                    titleEnglish: styles['editor-form-control'],
                    descriptionSpanish: styles['editor-form-control'],
                    descriptionEnglish: styles['editor-form-control'],
                    startDate: styles['editor-form-control'],
                    expirationDate: styles['editor-form-control'],
                    file: styles['document-file']
                }
            });
            return;
        }

        if (!!this.props.document && !!prevProps.document && prevProps.document.id !== this.props.document.id) {
            document = this.props.document;
            this.setState({
                id: document.id,
                file: null,
                titleSpanish: !!document ? document.title.es : '',
                titleEnglish: !!document ? document.title.en : '',
                descriptionSpanish: !!document ? document.description.es : '',
                descriptionEnglish: !!document ? document.description.en : '',
                startDate: !!document ? document.startDate : moment().format('YYYY-MM-DD'),
                expirationDate: !!document ? document.expirationDate : moment().add(1, 'months').format('YYYY-MM-DD'),
                uploadedFileName: null,
                missingArgumentsClass: {
                    titleSpanish: styles['editor-form-control'],
                    titleEnglish: styles['editor-form-control'],
                    descriptionSpanish: styles['editor-form-control'],
                    descriptionEnglish: styles['editor-form-control'],
                    startDate: styles['editor-form-control'],
                    expirationDate: styles['editor-form-control'],
                    file: styles['document-file']
                }
            });
        }
    }

    onDelete() {
        this.props.onDelete(this.state.id);
    }

    onDownload() {
        this.props.onDownload(this.state.id, this.props.document.fileName);
    }

    render() {
        let uploadFileLabel = this.context['DOCUMENTS_SELECT_FILE_DEFAULT'];
        if(!!this.state.uploadedFileName) {
            uploadFileLabel = this.state.uploadedFileName;
        }
        

        const labelClassName = `col-md-4`;
        const labelValueClassName = `col-md-8`;

        const dotStyle = {
            color: '#f00'
        }

        let header;
        let headerIcon = null;
        if (this.props.mode === 'create') {
            header = this.context['DOCUMENTS_NEW']
        } else {
            header = this.context['DOCUMENTS_UPDATE']
            headerIcon = <span className="float-right">
                <div className={styles['document-item-icon']}>
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{this.context['DOWNLOAD']}</Tooltip>}>
                    <ReactSVG src={downloadIcon} className={styles['save-button']} onClick={this.onDownload} />
                </OverlayTrigger>
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{this.context['DELETE']}</Tooltip>}>
                    <ReactSVG src={deleteIcon} className={styles['delete-button']} onClick={this.onDelete} />
                </OverlayTrigger> 
                </div>
            </span>
        }

        let uploadComponent;

        if(this.props.mode === 'update') {
            uploadComponent = <div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className='col-md-12'>
                        <p className={styles['editor-form-control-label']}>{this.context['DOCUMENTS_UPDATE_SECTION_TITLE']}</p>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['DOCUMENTS_UPDATE_FILENAME']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} value={this.props.document.fileName} type="text" readOnly disabled/>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['DOCUMENT_FILE']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <div className={styles['document-input-container']}>
                            <input type="file" name="document_file" id="document_file" className={styles['document-file']} onChange={this.onUploadFile} />
                            <label htmlFor="document_file"> 
                                <ReactSVG src={uploadIcon} className={styles['upload-button']} /> 
                                {uploadFileLabel}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        } else {
            uploadComponent = <div className={`row ${styles['editor-rows']}`}>
                <div className={labelClassName}>
                    <p className={styles['editor-form-control-label']}>{this.context['DOCUMENT_FILE']} <b style={dotStyle}>*</b>
                    </p>
                </div>
                <div className={labelValueClassName}>
                    <div className={styles['document-input-container']}>
                        <input type="file" name="document_file" id="document_file" className={this.state.missingArgumentsClass['file']} onChange={this.onUploadFile} />
                        <label htmlFor="document_file"> 
                            <ReactSVG src={uploadIcon} className={styles['upload-button']} /> 
                            {uploadFileLabel}
                        </label>
                    </div>
                </div>
            </div>
        }

        let dateErrorComponent;
        if(!!this.state.startDate && !!this.state.expirationDate) {
            if(!moment(this.state.expirationDate).isAfter(this.state.startDate)) {
                dateErrorComponent = <div className={`row ${styles['editor-rows']}`}>
                    <div className={`col-md-12 ${styles['editor-error-container']}`}>
                        <div className={styles['editor-error-message']}>
                            <b>{this.context['DOCUMENTS_DATE_ERROR']}</b>
                        </div>
                    </div>
                </div>
            }
        }

        return <div className="card">
            <div className="card-header">
                {header}
                {headerIcon}
            </div>
            <div className={`card-body ${styles['editor-rows']}`}>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className='col-md-12'>
                        <p className={styles['editor-form-control-label']}>{this.context['SPANISH']}</p>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['TITLE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['titleSpanish']} value={this.state.titleSpanish} type="text" onChange={(e) => this.setState({ titleSpanish: e.target.value })} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['DESCRIPTION']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['descriptionSpanish']} value={this.state.descriptionSpanish} type="text" onChange={(e) => this.setState({ descriptionSpanish: e.target.value })} />
                    </div>
                </div>
                <div className={styles['divider']}></div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className='col-md-12'>
                        <p className={styles['editor-form-control-label']}>{this.context['ENGLISH']}</p>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['TITLE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['titleEnglish']} value={this.state.titleEnglish} type="text" onChange={(e) => this.setState({ titleEnglish: e.target.value })} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['DESCRIPTION']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['descriptionEnglish']} value={this.state.descriptionEnglish} type="text" onChange={(e) => this.setState({ descriptionEnglish: e.target.value })} />
                    </div>
                </div>
                <div className={styles['divider']}></div>
                {uploadComponent}
                <div className={styles['divider']}></div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className='col-md-12'>
                        <p className={styles['editor-form-control-label']}>{this.context['DOCUMENTS_AVAILABILITY_SECTION_TITLE']}</p>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['START_DATE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['startDate']} value={this.state.startDate} type="date" onChange={this.onStartDateChange} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['EXPIRATION_DATE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['expirationDate']} value={this.state.expirationDate} type="date" onChange={this.onExpirationDateChange} />
                    </div>
                </div>
                {dateErrorComponent}
            </div>
            <div className="card-footer">
                <span className="float-right">
                    <Button variant="success" onClick={() => this.save()}>
                        {this.context['SAVE']}
                    </Button>
                </span>
                <span className="float-right">
                    <Button variant="danger" onClick={() => this.props.onCancel()}>
                        {this.context['CLOSE']}
                    </Button>
                </span>
            </div>
        </div>
    }
}

const ConfirmDeleteModal = (props) => {
    if(!props.show) {  
        return '';
    }

    const createMarkup = (content) => {
        return {
            __html: content
        };
    }

    const title = props.title;
    const context = props.context;

    return <Modal show={props.show} onHide={props.onClose}>
        <Modal.Header closeButton>
            <Modal.Title>{context['DOCUMENTS_DELETE_CONFIRM_TITLE']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div dangerouslySetInnerHTML={createMarkup(sprintf(context['DOCUMENTS_DELETE_CONFIRM_BODY'], title))} />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={props.onClose}>
                {context['CLOSE']}
            </Button>
            <Button variant="danger" onClick={() => props.onDelete(props.id)}>
                {context['DELETE']}
            </Button>
        </Modal.Footer>
    </Modal>
}

class SuccessSaveModal extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            show: props.show
        }

        this.onHide = this.onHide.bind(this);
    }

    onHide() {
        this.props.onHide();
    }

    render() {
        return <Modal show={this.props.show} onHide={this.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{this.context['DOCUMENTS_SAVED_SUCCESSFULLY_TITLE']}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{this.context['DOCUMENTS_SAVED_SUCCESSFULLY_BODY']}</Modal.Body>
        </Modal>
    }
}